import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { OverlayContainerService } from '../overlay-container/overlay-container.service';

@Injectable()
export class LoaderScreenServiceV2 {
    private _processCounter = 0;
    private _loaderScreenKey = 'loader-screen';
    private _$loaderActive: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private _overlayContainerService: OverlayContainerService) {}

    start(customClassList = ['fa', 'fa-cog', 'fa-spin', 'fa-3x', 'fa-fw'], hasShadow = false): void {
        this._processCounter++;
        const open = this._$loaderActive.getValue();
        if (!open) {
            const nativeElement: HTMLElement = this._overlayContainerService.getContainerElement(this._loaderScreenKey);
            nativeElement.classList.add('drg-overlay-container');
            const _innerElement = this._overlayContainerService.generateEmptyHtmlElement('i');
            customClassList.forEach((_class) => {
                _innerElement.classList.add(_class);
            });
            nativeElement.appendChild(_innerElement);

            if (hasShadow) {
                this._appendShadow(nativeElement);
            }
            this._$loaderActive.next(true);
        }
    }

    stop(): void {
        this._processCounter--;
        const open = this._$loaderActive.getValue();
        if (open && this._processCounter <= 0) {
            this._overlayContainerService.removeContainerElement(this._loaderScreenKey);
            this._$loaderActive.next(false);
        }
    }

    private _appendShadow(nativeElement: HTMLElement) {
        const _innerElement = this._overlayContainerService.generateEmptyHtmlElement('i');
        _innerElement.classList.add('loader-shadow');
        nativeElement.appendChild(_innerElement);
    }
}
